export function PAYMENT_TYPE_REQUEST(state) {
  state;
  state.paymentTypes = {
    ...state.paymentTypes,
    isLoading: true
  };
}
export function PAYMENT_TYPE_SUCCESS(state, payload) {
  payload.data.data.paymentTypes.map(item => {
    const testItem = Object.keys(item).map(value => {
      if (item[value] === null) {
        item[value] = "-";
      }
      return item;
    });
    return testItem;
  });
  state;
  state.paymentTypes = {
    ...state.paymentTypes,
    data: payload.data.data.paymentTypes,
    status: payload.data.status,
    count: payload.data.data.totalPage,
    isLoading: false
  };
}
export function PAYMENT_TYPE_ERROR(state, payload) {
  state;
  state.paymentTypes = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}
